import { VideoRequestStatus, VideoRequestSummaryModel } from "@/api/VideoRequest";

const VideoRequestInProgressMarker = (address: string) => `<svg
version="1.1"
data-cy="${address}"
xmlns="http://www.w3.org/2000/svg"
xmlns:xlink="http://www.w3.org/1999/xlink"
x="0px"
y="0px"
viewBox="0 0 60 60"
style="enable-background:new 0 0 60 60;"
xml:space="preserve"
class="video-request-in-progress-marker"
>
  <style type="text/css">
    .video-request-in-progress-marker .st0 {
      fill: none;
      stroke: #b2b2b2;
      stroke-miterlimit: 10;
    }
    .video-request-in-progress-marker .st1 {
      fill: #b2b2b2;
    }
    .video-request-in-progress-marker .st2 {
      fill: url(#video-request-in-progress-marker_Pin_1_);
    }
    .video-request-in-progress-marker .st3 {
      fill: #ffffff;
    }
    .video-request-in-progress-marker .st4 {
      fill: #2ead4a;
    }
    .video-request-in-progress-marker .st5 {
      fill: none;
      stroke: #ffffff;
      stroke-miterlimit: 10;
    }
    .video-request-in-progress-marker .st6 {
      fill: none;
      stroke: #ffffff;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-miterlimit: 10;
    }
  </style>
  <switch>
    <g>
      <g id="Disk_2_">
        <ellipse id="Group_2_3_" class="st0" cx="30" cy="55.5" rx="15" ry="3.8" />
        <ellipse id="Group_1_3_" class="st1" cx="30" cy="55.5" rx="7.5" ry="1.9" />
      </g>

      <linearGradient id="video-request-in-progress-marker_Pin_1_" gradientUnits="userSpaceOnUse" x1="30" y1="782.5" x2="30" y2="837.5" gradientTransform="matrix(1 0 0 1 0 -782)">
        <stop offset="0" style="stop-color:#D8D8D7" />
        <stop offset="1" style="stop-color:#808080" />
      </linearGradient>
      <path id="Pin_2_" class="st2" d="M52,22.5c0,12.2-22,33-22,33S8,34.7,8,22.5s9.9-22,22-22S52,10.4,52,22.5z" />
      <circle class="st3" cx="30" cy="22" r="18" />
      <g>
        <circle class="st4" cx="52" cy="8" r="8" />
      </g>
      <g>
        <g>
          <g>
            <path
              class="st4"
              d="M30.4,16.5c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8S33.6,16.5,30.4,16.5z M30.4,26.3
                      c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S32.6,26.3,30.4,26.3z"
            />
            <path
              class="st4"
              d="M39.5,13.7h-3.4c-0.1,0-0.2-0.1-0.3-0.2l-0.9-2c0,0,0,0,0,0c-0.4-0.7-1.1-1.2-1.9-1.2h-5.1
                      c-0.8,0-1.6,0.5-1.9,1.2c0,0,0,0,0,0l-0.9,2c-0.1,0.1-0.1,0.2-0.3,0.2h-3.5c-1.5,0-2.8,1.3-2.8,2.8v12.6c0,1.5,1.3,2.8,2.8,2.8
                      h18.3c1.5,0,2.8-1.3,2.8-2.8V16.5C42.3,14.9,41.1,13.7,39.5,13.7z M40.5,29.1c0,0.5-0.4,0.9-0.9,0.9H21.3
                      c-0.5,0-0.9-0.4-0.9-0.9V16.5c0-0.5,0.4-0.9,0.9-0.9h3.5c0.8,0,1.6-0.5,1.9-1.2c0,0,0,0,0,0l0.9-2c0.1-0.1,0.1-0.2,0.3-0.2H33
                      c0.1,0,0.2,0.1,0.3,0.2l0.9,2c0,0,0,0,0,0c0.4,0.7,1.1,1.2,1.9,1.2h3.4c0.5,0,0.9,0.4,0.9,0.9V29.1z"
            />
            <rect x="36.7" y="17.4" class="st4" width="1.9" height="1.9" />
          </g>
        </g>
      </g>
      <g>
        <ellipse transform="matrix(0.2299 -0.9732 0.9732 0.2299 32.3049 56.7737)" class="st5" cx="52" cy="8" rx="5.8" ry="5.8" />
        <polyline class="st6" points="52,12 52,8 50,6 			" />
      </g>
    </g>
  </switch>
</svg>
`;

const VideoRequestCompleteMarker = (address: string) => `<svg version="1.1" id="${address}"
xmlns="http://www.w3.org/2000/svg"
xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve"
class="video-request-complete-marker">
<style type="text/css">
    .video-request-complete-marker .st0 {
      fill: none;
      stroke: #b2b2b2;
      stroke-miterlimit: 10;
    }
    .video-request-complete-marker .st1 {
      fill: #b2b2b2;
    }
    .video-request-complete-marker .st2 {
      fill: url(#video-request-complete-marker_Pin_2_);
    }
    .video-request-complete-marker .st3 {
      fill: #ffffff;
    }
    .video-request-complete-marker .st4 {
      fill: #2ead4a;
    }
</style>
<switch>
  <g>
    <g id="Disk_1_">
      <ellipse id="Group_2_2_" class="st0" cx="30" cy="55.5" rx="15" ry="3.8" />
      <ellipse id="Group_1_2_" class="st1" cx="30" cy="55.5" rx="7.5" ry="1.9" />
    </g>

    <linearGradient id="video-request-complete-marker_Pin_2_" gradientUnits="userSpaceOnUse" x1="30" y1="782.5" x2="30" y2="837.5" gradientTransform="matrix(1 0 0 1 0 -782)">
      <stop offset="0" style="stop-color:#D8D8D7" />
      <stop offset="1" style="stop-color:#808080" />
    </linearGradient>
    <path id="Pin_1_" class="st2" d="M52,22.5c0,12.2-22,33-22,33S8,34.7,8,22.5s9.9-22,22-22S52,10.4,52,22.5z" />
    <circle class="st3" cx="30" cy="22" r="18" />
    <g>
      <circle class="st4" cx="52" cy="8" r="8" />
    </g>
    <g>
      <g>
        <g>
          <path class="st4" d="M30.4,16.5c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8S33.6,16.5,30.4,16.5z M30.4,26.3
                      c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S32.6,26.3,30.4,26.3z" />
          <path class="st4" d="M39.5,13.7h-3.4c-0.1,0-0.2-0.1-0.3-0.2l-0.9-2c0,0,0,0,0,0c-0.4-0.7-1.1-1.2-1.9-1.2h-5.1
                      c-0.8,0-1.6,0.5-1.9,1.2c0,0,0,0,0,0l-0.9,2c-0.1,0.1-0.1,0.2-0.3,0.2h-3.5c-1.5,0-2.8,1.3-2.8,2.8v12.6c0,1.5,1.3,2.8,2.8,2.8
                      h18.3c1.5,0,2.8-1.3,2.8-2.8V16.5C42.3,14.9,41.1,13.7,39.5,13.7z M40.5,29.1c0,0.5-0.4,0.9-0.9,0.9H21.3
                      c-0.5,0-0.9-0.4-0.9-0.9V16.5c0-0.5,0.4-0.9,0.9-0.9h3.5c0.8,0,1.6-0.5,1.9-1.2c0,0,0,0,0,0l0.9-2c0.1-0.1,0.1-0.2,0.3-0.2H33
                      c0.1,0,0.2,0.1,0.3,0.2l0.9,2c0,0,0,0,0,0c0.4,0.7,1.1,1.2,1.9,1.2h3.4c0.5,0,0.9,0.4,0.9,0.9V29.1z" />
          <rect x="36.7" y="17.4" class="st4" width="1.9" height="1.9" />
        </g>
      </g>
    </g>
    <g>
      <path class="st3" d="M46.7,9l3.3,3.6c0.1,0.2,0.4,0.2,0.6,0l6.8-7.8c0.1-0.1,0.1-0.4,0-0.5l-1-1.1c-0.2-0.2-0.4-0.2-0.6,0
              l-5.4,6.9c-0.1,0.1-0.2,0.1-0.3,0l-1.8-2.5c-0.1-0.2-0.4-0.2-0.6,0l-0.9,0.9C46.6,8.7,46.6,8.9,46.7,9z" />
    </g>
  </g>
</switch>
</svg>`;

const VideoRequestFailedMarker = (address: string) => `<svg version="1.1" id="${address}"
xmlns="http://www.w3.org/2000/svg"
xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve"
class="video-request-failed-marker">
<style type="text/css">
    .video-request-failed-marker .st0 {
      fill: none;
      stroke: #b2b2b2;
      stroke-miterlimit: 10;
    }
    .video-request-failed-marker .st1 {
      fill: #b2b2b2;
    }
    .video-request-failed-marker .st2 {
      fill: url(#video-request-failed-marker_Pin_1_);
    }
    .video-request-failed-marker .st3 {
      fill: #ffffff;
    }
    .video-request-failed-marker .st4 {
      fill: #ffc629;
    }
    .video-request-failed-marker .st5 {
      fill: #2ead4a;
    }
</style>
<switch>
  <g>
    <g id="Disk_3_">
      <ellipse id="Group_2_4_" class="st0" cx="30" cy="55.5" rx="15" ry="3.8" />
      <ellipse id="Group_1_4_" class="st1" cx="30" cy="55.5" rx="7.5" ry="1.9" />
    </g>

    <linearGradient id="video-request-failed-marker_Pin_1_" gradientUnits="userSpaceOnUse" x1="30" y1="782.5" x2="30" y2="837.5" gradientTransform="matrix(1 0 0 1 0 -782)">
      <stop offset="0" style="stop-color:#D8D8D7" />
      <stop offset="1" style="stop-color:#808080" />
    </linearGradient>
    <path id="Pin_3_" class="st2" d="M52,22.5c0,12.2-22,33-22,33S8,34.7,8,22.5s9.9-22,22-22S52,10.4,52,22.5z" />
    <circle class="st3" cx="30" cy="22" r="18" />
    <g>
      <circle class="st4" cx="52" cy="8" r="8" />
    </g>
    <g>
      <g>
        <g>
          <path class="st5" d="M30.4,16.5c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8S33.6,16.5,30.4,16.5z M30.4,26.3
                      c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S32.6,26.3,30.4,26.3z" />
          <path class="st5" d="M39.5,13.7h-3.4c-0.1,0-0.2-0.1-0.3-0.2l-0.9-2c0,0,0,0,0,0c-0.4-0.7-1.1-1.2-1.9-1.2h-5.1
                      c-0.8,0-1.6,0.5-1.9,1.2c0,0,0,0,0,0l-0.9,2c-0.1,0.1-0.1,0.2-0.3,0.2h-3.5c-1.5,0-2.8,1.3-2.8,2.8v12.6c0,1.5,1.3,2.8,2.8,2.8
                      h18.3c1.5,0,2.8-1.3,2.8-2.8V16.5C42.3,14.9,41.1,13.7,39.5,13.7z M40.5,29.1c0,0.5-0.4,0.9-0.9,0.9H21.3
                      c-0.5,0-0.9-0.4-0.9-0.9V16.5c0-0.5,0.4-0.9,0.9-0.9h3.5c0.8,0,1.6-0.5,1.9-1.2c0,0,0,0,0,0l0.9-2c0.1-0.1,0.1-0.2,0.3-0.2H33
                      c0.1,0,0.2,0.1,0.3,0.2l0.9,2c0,0,0,0,0,0c0.4,0.7,1.1,1.2,1.9,1.2h3.4c0.5,0,0.9,0.4,0.9,0.9V29.1z" />
          <rect x="36.7" y="17.4" class="st5" width="1.9" height="1.9" />
        </g>
      </g>
    </g>
    <g>
      <path class="st3" d="M50.4,2.5h3.2V5L53,9.6h-2L50.4,5V2.5z M50.5,10.8h3v2.7h-3V10.8z" />
    </g>
  </g>
</switch>
</svg>`;

export const videoRequestMarker = (videoRequest: VideoRequestSummaryModel) => {
  switch (videoRequest.status) {
    case VideoRequestStatus.InProgress:
      return VideoRequestInProgressMarker(videoRequest.title.replace(/ /g, ""));
    case VideoRequestStatus.Complete:
      return VideoRequestCompleteMarker(videoRequest.title.replace(/ /g, ""));
    case VideoRequestStatus.Failed:
      return VideoRequestFailedMarker(videoRequest.title.replace(/ /g, ""));
  }
};
